module.exports = __webpack_public_path__ + "img/张雅明.ddf93d87.png";